export default __webpack_public_path__ + "8ae81b04c273cfc8e95232f23c99c67b.gif";